import 'tslib';
import './has-setup';

// load needed polyfills
import '@dojo/framework/shim/browser';

// supported moment locales
import 'moment/locale/es';
import 'moment/locale/fr';

// PWA support
// import 'pwacompat';

// App config & startup
import { LccApp, registry, onlineChange, ditarootsChange } from '@holmescorp/lcc-app';
import { siteInit } from '@holmescorp/site-init';
// site-specific init
import { register_lp_widgets, setup_actions } from '@holmescorp/ascm-init';
// site-specific theme
import sitetheme from '@holmescorp/ascm-theme';
import { themeContext } from '@holmescorp/lcc-state';

// A2HS support
// import { AddToHomeWidget } from 'add-to-home';
// registry.define('AddToHomeScreen', AddToHomeWidget);

// patch in ResizeObserver polyfill if necessary
import global from '@dojo/framework/shim/global';
import ResizeObserver from 'resize-observer-polyfill';

if (!global.ResizeObserver) {
	global.ResizeObserver = ResizeObserver;
}

// Set the theme
themeContext.set(sitetheme, (window as any).hcstatic.portal_site);

register_lp_widgets();
setup_actions();

// Start the site
siteInit(LccApp, registry, onlineChange);
